// Customer 360 · "Who's worked this customer" — staff touches by source.
import { useEffect, useState } from "react";
import { Users } from "lucide-react";
import api from "../../lib/api";

const SRC = [["quote_owner", "quote", "quotes"], ["quote_won", "won", "won"], ["call", "call", "calls"], ["whatsapp", "WhatsApp", "WhatsApps"], ["front", "email", "emails"], ["activity", "activity", "activities"], ["quote_collab", "collab", "collabs"]];

export default function AMTouchesCard({ personId }) {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get(`/crm/persons/${personId}/am-touches`).then(({ data }) => setItems(data.items)).catch(() => setItems([])); }, [personId]);
  if (!items) return null;
  return (
    <div className="rounded-xl border border-white/10 bg-white/[0.02] p-4" data-testid="am-touches-card">
      <div className="flex items-center gap-2 mb-2"><Users className="w-4 h-4 text-teal-300" /><span className="text-sm font-semibold text-white">Staff who've worked this customer</span></div>
      {items.length === 0 ? <div className="text-[12px] text-slate-500" data-testid="am-touches-empty">No staff touches recorded yet.</div> : (
        <div className="space-y-1.5">
          {items.map((t, i) => (
            <div key={t.staff_id} className="flex items-center gap-2 text-[12px]" data-testid={`am-touch-${i}`}>
              <span className="text-white font-medium min-w-[140px]">{t.name}</span>
              <span className="text-slate-400 flex-1">{SRC.filter(([k]) => t[k]).map(([k, one, many]) => `${t[k]} ${t[k] === 1 ? one : many}`).join(" · ")}</span>
              <span className="text-[10.5px] font-mono text-slate-500">{t.last ? new Date(t.last).toLocaleDateString("en-GB") : ""}</span>
              <span className="text-[10.5px] font-mono text-teal-300 w-10 text-right">{t.score}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
